import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { PlaceOrderOperation } from '../../mappers/server/place-order-operation-mapper.js';
import { PLACE_ORDER } from '../../operations/mutations/place-order.js';

const usePlaceOrder = ()=>{
    const [mutationCallback, { loading , error: error1  }] = useMutation(PLACE_ORDER);
    const placeOrder = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(orderInputProp) {
            return yield mutationCallback({
                variables: {
                    placeOrderInput: PlaceOrderOperation.placeOrderInput(orderInputProp)
                }
            }).then(({ data , errors  })=>{
                if (data) {
                    return PlaceOrderOperation.placeOrderOutput(data);
                }
                errors === null || errors === void 0 ? void 0 : errors.forEach((error)=>console.log('[error]:', error.message)
                );
                return {
                    success: false,
                    redirect: false
                };
            }).catch((error)=>{
                console.error('[error]:', error);
                return {
                    success: false,
                    redirect: false
                };
            });
        });
        return function(orderInputProp) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutationCallback
    ]);
    return {
        isUpdating: loading,
        updateError: error1,
        placeOrder
    };
};

export { usePlaceOrder };
//# sourceMappingURL=use-place-order.js.map
